export default [
  {
    path: '/',
    name: 'Home',
    meta: { layout: 'side-nav' },
    component: (r) => require(['@/pages/index'], r)
  },
  {
    path: '/onboard/:id',
    meta: { allowAnonymous: true },
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Onboard',
        meta: { layout: 'no-nav' },
        component(r) {
          require(['@/pages/onboard/index'], r)
        }
      }
    ]
  },
  {
    path: '/contacts',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Contacts',
        meta: { layout: 'default' },
        component: (r) => require(['@/pages/contacts/index'], r)
      }
    ]
  },
  {
    path: '/insurance',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Insurance',
        meta: { layout: 'default' },
        component: (r) => require(['@/pages/insurance/index'], r)
      }
    ]
  },
  {
    path: '/dashboard',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Dashboard',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/dashboard/index'], r)
        }
      }
    ]
  },
  {
    path: '/locations',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Locations',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/locations/index'], r)
        }
      }
    ]
  },
  {
    path: '/adas',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'ADAS',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/adas/index'], r)
        }
      }
    ]
  },
  {
    path: '/admin',
    name: 'Administration',
    meta: { layout: 'side-nav' },
    component: (r) => require(['@/pages/admin/index'], r)
  },
  {
    path: '/configuration',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Configuration Settings',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/admin/configuration/index'], r)
        }
      }
    ]
  },
  {
    path: '/data',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Import/Export Facility',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/admin/import-data/index'], r)
        }
      }
    ]
  },
  {
    path: '/users',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Users',
        meta: { layout: 'default' },
        component: (r) => require(['@/pages/users/index'], r)
      }
    ]
  },
  {
    path: '/storage',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Storage',
        meta: { layout: 'default' },
        component: (r) => require(['@/pages/storage/index'], r)
      }
    ]
  },
  {
    path: '/add-inspection',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Add Inspection',
        meta: { layout: 'default' },
        component: (r) => require(['@/pages/adas/add-inspection'], r)
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    meta: { allowAnonymous: true },
    component: (r) => require(['@/pages/login/index'], r)
  },
  {
    path: '/reset',
    name: 'Reset Password',
    meta: { allowAnonymous: true },
    component: (r) => require(['@/pages/login/reset'], r)
  },
  {
    path: '/sso',
    name: 'sso',
    meta: { allowAnonymous: true },
    component: (r) => require(['@/pages/login/sso'], r)
  },
  {
    path: '*',
    name: 'Page not Found',
    component: (r) => require(['@/pages/errors/error-404'], r)
  },
  {
    path: '/alldataAuthorize',
    name: 'alldataAuthorize',
    meta: { allowAnonymous: true },
    component: (r) => require(['@/pages/login/alldata-authorize'], r)
  },
  {
    path: '/alldataApproval',
    name: 'alldataApproval',
    meta: { allowAnonymous: true },
    component: (r) => require(['@/pages/login/alldata-approval'], r)
  },
  {
    path: '/alldataSetToken',
    name: 'alldataSetToken',
    meta: { allowAnonymous: true },
    component: (r) => require(['@/pages/login/alldata-settoken'], r)
  },
  {
    path: '/links',
    name: 'links',
    meta: { allowAnonymous: true },
    component: (r) => require(['@/pages/links/index'], r)
  },
  {
    path: '/providers',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Providers',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/providers/index'], r)
        }
      }
    ]
  },
  {
    path: '/view',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Inspection',
        meta: { layout: 'default' },
        component: (r) => require(['@/pages/adas/view-inspection'], r)
      }
    ]
  },
  {
    path: '/blueprint',
    name: 'Inspection',
    meta: { allowAnonymous: true },
    component: (r) => require(['@/pages/adas/blueprint-inspection'], r)
  },
  {
    path: '/choose',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'Choose Vehicle',
        meta: { layout: 'default' },
        component: (r) => require(['@/pages/adas/choose-vehicle'], r)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js